import React from 'react';
import './index.scss';

export default function(){
    return(
        <p>Integrations Partner on Progress</p>
    );
}